import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Login from './components/Login';
import HomePage from './pages/HomePage';
import UsersPage from './pages/UsersPage';
import VagasPage from './pages/VagasPage';
import Box from '@mui/material/Box';
import Footer from "./components/Footer"; 
import Paper from '@mui/material/Paper';
import { jwtDecode } from "jwt-decode";
import isTokenExpired from "./components/verifyTokenExpired.jsx";

function PrivateRoute({ user, loading, children }) {
  if (loading) return null;
  return user && (user.is_admin || user.is_funcionario)
    ? children
    : <Navigate to="/" replace />;
}

function AdminRoute({ user, loading, children }) {
  if (loading) return null;
  return user && user.is_admin
    ? children
    : <Navigate to="/" replace />;
}

function App() {

  const [showLogin, setShowLogin] = useState(false);

  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    if (isTokenExpired()) {
      localStorage.removeItem("token");
      setUser(null);
      setToken(null);
      setAuthChecked(true);
      return;
    }

    if (!token) {
      setUser(null);
      setAuthChecked(true);
      return;
    }

    try {
      const decoded = jwtDecode(token);
      setUser(decoded);
    } catch (err) {
      setUser(null);
      setToken(null);
      localStorage.removeItem("token");
    } finally {
      setAuthChecked(true);
    }
  }, [token]);

  const handleLoginSuccess = (token) => {
    localStorage.setItem("token", token);
    setToken(token);

    try {
      const decoded = jwtDecode(token);
      setUser(decoded);
    } catch (err) {
      console.error("Erro ao decodificar token:", err);
    }

    setShowLogin(false);
  };

  // Logout
  const handleLogout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
  };

  return (
    <BrowserRouter>
      <Navbar
        user={user}
        onLogout={handleLogout}
        onShowLogin={() => setShowLogin(true)}
      />
      <Box style={{ backgroundColor: "gainsboro", marginTop: "50px" }}>
        <Paper
          className="container pr-1 pl-1 pb-1"
          style={{
            backgroundColor: "white",
            minWidth: "90%",
            minHeight: "81vh",
            paddingTop: "10px"
          }}
          elevation={24}
        >
          <Routes>
            <Route path="/" element={<HomePage user={user} />} />
            <Route
              path="/vagas"
              element={
                <PrivateRoute user={user} loading={!authChecked}>
                  <VagasPage user={user} />
                </PrivateRoute>
              }
            />

            <Route
              path="/usuarios"
              element={
                <AdminRoute user={user} loading={!authChecked}>
                  <UsersPage user={user} />
                </AdminRoute>
              }
            />
          </Routes>
          {showLogin && !token && (
            <Login
              onLogin={handleLoginSuccess}
              onClose={() => setShowLogin(false)}
            />
          )}
        </Paper>
        <Footer />
      </Box>
    </BrowserRouter>
  );
}

export default App;
